import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/JenacaProfilePicRenown.jpeg'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Profile Pic",
  src: _imports_0
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_v_container, { class: "bg-surface-variant" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, { "no-gutters": "" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_sheet, { class: "ma-2 pa-2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      title: "Web Developer",
                      text: "test"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_sheet, { class: "ma-2 pa-2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      title: "Radiant Analyst",
                      text: "test"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_sheet, { class: "ma-2 pa-2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      title: "Caboodle Developer",
                      text: "test"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}